import CalendlyButton, { type CalendlyProps } from "components/CalendlyButton"
import { ReactComponent as ArrowSVG } from "images/arrowUpRight.svg"
import { fresponsive } from "library/fullyResponsive"
import type { ReactNode } from "react"
import styled, { css, keyframes } from "styled-components"
import colors from "styles/colors"
import textStyles from "styles/text"

const ease = "cubic-bezier(0.76, 0, 0.09, 1)"

export default function ArrowButton({
	children,
	className,
	...props
}: CalendlyProps & {
	children: ReactNode
	className?: string
}) {
	return (
		<Wrapper {...props} className={className}>
			<Marquee>
				<Slide>
					{children}
					<Arrow />
				</Slide>
				<Slide>
					{children}
					<Arrow />
				</Slide>
				<Slide>
					{children}
					<Arrow />
				</Slide>
				<Slide>
					{children}
					<Arrow />
				</Slide>
				<Slide>
					{children}
					<Arrow />
				</Slide>
				<Slide>
					{children}
					<Arrow />
				</Slide>
			</Marquee>
			<Text>
				{children}
				<ArrowLarge />
			</Text>
		</Wrapper>
	)
}

const marqueeAnimation = keyframes`
  from {
    translate: -50% 0;
  }
  to {
    translate: -150% 0;
  }
`

const Marquee = styled.div`
	position: absolute;
	display: flex;
	translate: 0 500%;
	transition: translate 0.6s ${ease};
`

const Text = styled.div`
	transition: translate 0.6s ${ease};
	width: 100%;
	text-align: center;
`

const Wrapper = styled(CalendlyButton)`
	position: relative;
	${textStyles.sub1}
	color: ${colors.pureWhite};
	background-color: ${colors.blue2};
	display: block;
	overflow: clip;
	transition:
		border 0.6s ${ease},
		background 0.6s ${ease};

	${fresponsive(css`
		border-radius: 12px;
		padding: 25px 45px;
	`)}

	&:hover {
		border: 1px solid ${colors.blue3};
		background: ${colors.transBlue1};

		${Text} {
			translate: 0 -500%;
		}

		${Marquee} {
			translate: 0 0;
		}
	}
`

const Slide = styled.div`
	${fresponsive(css`
		gap: 9px;
		padding-left: 9px;
	`)}

	display: flex;
	white-space: nowrap;
	align-items: center;
	animation: ${marqueeAnimation} 3s linear infinite;
	color: ${colors.blue3};

	path {
		stroke: ${colors.blue3};
	}
`

const Arrow = styled(ArrowSVG)`
	${fresponsive(css`
		width: 9px;
		height: 9px;
	`)}
`

const ArrowLarge = styled(ArrowSVG)`
	path {
		stroke: ${colors.pureWhite};
	}

	${fresponsive(css`
		width: 15px;
		height: 15px;
		margin-left: 10px;
	`)}
`
